import { PcrPayScale } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale'
import { PcrPayScaleInput } from '../../lib/types/models/pcr-pay-scales/pcr-pay-scale-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updatePcrPayScale(data: UpdateInput<PcrPayScaleInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.pcrPayScale.update.url, { id }))
    .patch<PcrPayScale, Partial<PcrPayScaleInput>>(rest)
}
